module.exports = __webpack_public_path__ + "static/hospitality-16704bc15e4229010f9a48e26e570a7e.jpg";